import { useOrganizationId } from '@apps/web/hooks/use_organization_id';
import { useFeatureFlag } from '@apps/web/lib/feature_flag_overrides';
import {
    useOrganization,
    useUser,
} from '@apps/web/swr_data_fetching/data_fetching_hooks';

export function useThemeEnabled(): boolean | undefined {
    const organizationId = useOrganizationId();
    const { data: organization, error: organizationError } = useOrganization(
        organizationId,
        {
            reason: 'theme-availability',
        },
    );
    const { data: user, error: userError } = useUser({
        reason: 'theme-availability',
    });
    const organizationEnabled = useFeatureFlag(
        'dark_mode_enabled',
        organization?.id === organizationId ? organization.features : undefined,
    );
    if (user?.admin) {
        return true;
    }
    if (user === undefined) {
        return userError ? false : undefined;
    }
    if (organization?.id !== organizationId) {
        return organizationError ? false : undefined;
    }
    return organizationEnabled;
}
